import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "../Url";

export const saveFirmPanActions = {
  SAVE_FIRM_PAN_DETAILS_SUCCESS: "SAVE_FIRM_PAN_DETAILS_SUCCESS",
  SAVE_FIRM_PAN_DETAILS_ERROR: "SAVE_FIRM_PAN_DETAILS_ERROR",
};

export function saveFirmPanDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/savePartnerPANDetails?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(savePanApplicantDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(savePanApplicantDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(savePanApplicantDetailsError(err));
          return err.response;
        }
      });
}

export function savePanApplicantDetailsError(error) {
  return {
    type: saveFirmPanActions.SAVE_FIRM_PAN_DETAILS_ERROR,
    payload: error,
  };
}

export function savePanApplicantDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveFirmPanActions.SAVE_FIRM_PAN_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
